import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  getAllLanguageOptions,
  getLabelCode,
  getLanguageLabel,
} from "../../utils/languageLabels";

const LanguageSwitcher = ({ isMenuAbove = false, ...props }) => {
  const { t, i18n } = useTranslation("common");
  const [isOpen, setIsOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState();

  const languages = getAllLanguageOptions();
  const displaySelectedCode = getLabelCode(selectedItem);

  const handleSelectItemClick = (item) => {
    const languageCode = getLabelCode(item);

    i18n.changeLanguage(languageCode);
    setSelectedItem(item);
    setIsOpen(false);
  };

  useEffect(() => {
    const lang = getLanguageLabel(i18n.language);
    setSelectedItem(lang);
  }, [i18n.language]);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="pointer-events-auto shadow-light inline-flex items-center w-full min-w-max justify-center gap-x-3 rounded-full bg-white px-6 py-3 text-sm font-bold text-primary hover:shadow-sm"
        id="map-view-button"
        {...props}
      >
        {displaySelectedCode?.toLocaleUpperCase() ||
          t("languageSwitcher.placeholder")}
        <img src="/images/arrow_down.svg" alt="arrow icon pointing down" />
      </button>
      {isOpen && (
        <div
          className={`min-w-full absolute z-50 py-3 rounded-lg bg-white shadow-lg ring-1 overflow-hidden ring-black ring-opacity-5 focus:outline-none left-1/2 transform -translate-x-1/2 ${
            isMenuAbove ? "bottom-full mb-2" : "top-full mt-2"
          }`}
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div role="none">
            {languages?.map((item, index) => (
              <div key={index}>
                <button
                  className={`flex w-full justify-center items-center px-6 py-3 font-bold hover:text-primary cursor-pointer transition-colors ${selectedItem === item ? "text-primary" : "text-black"}`}
                  role="menuitem"
                  onClick={() => handleSelectItemClick(item)}
                >
                  <p className="text-sm leading-none whitespace-nowrap">
                    {item}
                  </p>
                </button>

                {index < languages.length - 1 && (
                  <div className="border-b border-black w-3/12 mx-auto" />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
